export const latestAbandonedCartItemsQuery = `
query GetLatestAbandonedCartItems {
  cartItemsV2All(first: 10, page: 1) {
    data {
      product {
        title
      }
      productName
      user {
        name
        id
      }
      created_at
    }
  }
}
`

export const cartItemsV2ByUserQuery = `
query GetCartItemsV2ByUser($user_id: ID!) {
  cartItemsV2ByUser(user_id: $user_id, first: 20, page: 1) {
    data {
      id
      productId
      productName
      created_at
      product {
        id
        title
      }
    }
  }
}
`

export const adminDeleteCartItemV2Mutation = `
mutation AdminDeleteCartItemV2($id: ID!) {
  adminDeleteCartItemV2(id: $id)
}
`

export const adminDeleteCartItemsV2ByUserMutation = `
mutation AdminDeleteCartItemsV2ByUser($user_id: ID!) {
  adminDeleteCartItemsV2ByUser(user_id: $user_id)
}
`

